<template>
  <div class="pi-feedback-list">
    <div class="feedback-flex">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="您没有更多记录了哦"
        @load="onLoad"
        :immediate-check="false"
        class="list-container"
        ref="vanList"
      >
        <ul class="">
          <li
            class="feedback-item"
            v-for="(item, index) in list"
            :key="index"
            @click="goDetails(item)"
          >
            <div class="feedback-title-box">
              <div class="feedback-title">{{ item.createTime || "--" }}</div>
              <div
                class="feedback-status"
                :class="{ yes: item.processingStatus }"
              >
                {{ item.processingStatus ? "已处理" : "未处理" }}
              </div>
            </div>
            <div class="feedback-content text-hide">{{ item.content }}</div>
            <div class="icon">
              <img src="../../assets/img/icon-right.png" alt="" />
            </div>
          </li>
        </ul>
      </van-list>
    </div>
    <div class="go-feedback">
      <pi-button type="primary" block @click="gotoFeedback">我要反馈</pi-button>
    </div>
  </div>
</template>

<script>
import { List } from "vant";
import { getFeedList } from "../../common/api/index";
export default {
  name: "pi-feedback-list",
  components: {
    [List.name]: List,
  },
  data() {
    return {
      loading: false,
      finished: false,
      form: {
        chargeUserPkId: "",
        globalOrder: "",
        globalPageIndex: 1,
        globalPageSize: 10,
        globalSearch: "",
        nickName: "",
      },
      total: 0,
      list: [],
    };
  },
  mounted() {
    this.form.chargeUserPkId = this.$route.query.chargeUserPkId;
    this.getFeedList();
  },
  methods: {
    onLoad() {
      this.form.globalPageIndex++;
      this.getFeedList();
    },
    gotoFeedback() {
      this.$router.push({ name: "feedback" });
    },
    getFeedList() {
      getFeedList(this.form).then((response) => {
        if (response.status === this.$config.ajaxStatus) {
          let data = response.data;
          this.list = data.concat(this.list);
          this.total = response.total;
          if (this.list.length >= this.total) {
            this.finished = true;
          }
        }
      });
    },
    goDetails(item) {
      // this.$common.save('feedback-details',item);
      // console.log(item)
      this.$router.push("/feedback-details?feedbackPkId=" + item.pkid);
    },
  },
};
</script>

<style lang="less">
.pi-feedback-list {
  height: 100%;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  .feedback-flex {
    flex: 1;
  }
  .go-feedback {
    padding: 0.2rem;
  }
  .list-container {
    flex: 1;
    overflow-y: auto;
    padding: 0.2rem;
  }
  .feedback-item {
    background-color: #fff;
    border-radius: 0.1rem;
    padding: 0.2rem 0.5rem 0.2rem 0.2rem;
    margin-top: 0.2rem;
    position: relative;
    border-bottom: 0.01rem solid #eee;
    cursor: pointer;
    .icon {
      position: absolute;
      top: 50%;
      right: 0rem;
      transform: translateY(-50%);
      img {
        width: 0.4rem;
      }
    }
  }
  .feedback-item:first-child {
    margin-top: 0;
  }
  .feedback-title-box {
    display: flex;
    .feedback-title {
      font-size: 0.32rem;
      flex: 1;
    }

    .feedback-status {
      color: #999;
      font-size: 0.24rem;
    }
    .feedback-status.yes {
      color: #14cc80;
    }
  }
  .feedback-time {
    color: #999;
    font-size: 0.24rem;
  }
  .feedback-content {
    margin-top: 0.2rem;
    font-size: 0.28rem;
    color: #666;
  }
}
</style>
